import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontFamilyOptionList } from './FontFamilyOptionList';
import { ConfirmModal } from '@gift/ui/components/modal/ConfirmModal';

export const FontFamilyModal = ({
    selectedFontFamily,
    toggle, commit
}: Props) => {

    const { t } = useTranslation();
    const [localValue, setLocalValue] = useState(selectedFontFamily);

    const onConfirm = () => {
        commit(localValue);
        toggle();
    };

    return (
        <ConfirmModal
            title={t('styling_options.font_family')}
            active={true}
            onReject={toggle}
            onConfirm={onConfirm}>
            <FontFamilyOptionList
                selectedFontFamily={localValue}
                onClick={setLocalValue}
                gap='xs' />
        </ConfirmModal>
    );
};

type Props = {
    selectedFontFamily: string,
    toggle: () => void,
    commit: (fontFamily: string) => void
};
